export const treasury_policy_framework = [
  {
    id: 1,
    name: 'Agenda 2063',
    summary: 'shortsummary/Agenda 2063.html',
    link: 'Agenda 2063.pdf',
    audio_en: 'audio/en/Agenda 2063_en.mp3',
    audio_af: 'audio/af/Agenda 2063_af.mp3',
    audio_xh: 'audio/xh/Agenda 2063_xh.mp3'
  }
];